import React, { Suspense, useEffect, useState } from 'react';
import { Canvas, useLoader } from '@react-three/fiber';
import { OrbitControls, Stage } from '@react-three/drei';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import * as THREE from 'three';

const Model = ({ url, color }) => {
  const geometry = useLoader(STLLoader, url);
  
  // Center the geometry
  useEffect(() => {
    if (geometry) {
      geometry.center();
      geometry.computeVertexNormals();
    }
  }, [geometry]);

  return (
    <mesh geometry={geometry}>
      <meshStandardMaterial 
        color={color || 'grey'} 
        roughness={0.5}
        metalness={0.1}
      />
    </mesh>
  );
};

const ModelViewer = ({ fileUrl, color = 'grey', height = '300px' }) => {
  if (!fileUrl) return null;

  return (
    <div style={{ height: height, width: '100%', backgroundColor: '#f0f0f0', borderRadius: '8px', overflow: 'hidden' }}>
      <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 150], fov: 50 }}>
        <Suspense fallback={null}>
          <Stage environment="city" intensity={0.6}>
            <Model url={fileUrl} color={color} />
          </Stage>
        </Suspense>
        <OrbitControls autoRotate={false} />
      </Canvas>
    </div>
  );
};

export default ModelViewer;
